import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

const EditBank = () => {
  return (
    <div className="income-type-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Update Bank Details</h4>
      </div>

      <div className="yc-list-body">
        <div className="card">
          <div className="card-body">
            <Form>
              <Row className="g-3">
            {/* Account Holder */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Account Holder <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" placeholder="Enter account holder" />
              </Form.Group>
              {/* <small className="text-danger">
                Account Holder cannot be blank.
              </small> */}
            </Col>

            {/* Account Number */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Account Number <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" placeholder="Enter account number" />
              </Form.Group>
              {/* <small className="text-danger">
                Account Number cannot be blank.
              </small> */}
            </Col>

            {/* Bank Name */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Bank Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" placeholder="Enter bank name" />
              </Form.Group>
              {/* <small className="text-danger">Bank Name cannot be blank.</small> */}
            </Col>

            {/* Swift Code / IBAN / IFSC */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Swift Code / IBAN / IFSC{" "}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" placeholder="Enter code" />
              </Form.Group>
              {/* <small className="text-danger">
                Swift Code/IBAN/IFSC cannot be blank.
              </small> */}
            </Col>

            {/* Branch */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>Branch</Form.Label>
                <Form.Control type="text" placeholder="Enter branch" />
              </Form.Group>
            </Col>
          </Row>

          {/* Create Button */}
          <div className="mt-4 d-flex justify-content-end">
            <Button type="submit" className="btn btn-primary">
              Update
            </Button>
          </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditBank;
